import { useAuthContext } from './adminAuthHook'
import { getAllPackages } from '../redux/reducers/packagesSlice'
import { useDispatch } from 'react-redux';

export default function PackagesHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { admin } = useAuthContext()
    const getPackages=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/admin/packages/get`,{
          headers:{
            'Authorization': `Bearer ${admin.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllPackages(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getPackages}
}
